import React from 'react'

import { AgentCreate } from 'features/trend-detection/features/agent-create'

export const AgentCreatePage: React.FC = () => <AgentCreate />
